import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  @media (max-width: ", ") {\n    justify-items: center;\n    grid-template-columns: 1fr;\n    grid-row-gap: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
var Columns = styled.div(_templateObject(), function (_ref) {
  var gridTemplateColumns = _ref.gridTemplateColumns,
      count = _ref.count;
  return gridTemplateColumns || (count ? "repeat(".concat(count, ", 1fr)") : null);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing.md;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.md;
}, function (_ref4) {
  var theme = _ref4.theme,
      breakpoint = _ref4.breakpoint;
  return breakpoint ? theme.breakpoints[breakpoint] : null;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing.sm;
});
export default Columns;